const index = [
  {
    text: '',
    value: 'acoes'
  },
  {
    text: 'GRUPO',
    value: 'descricao'
  },
  {
    text: 'ENVIADO',
    value: 'data_envio'
  },
  {
    text: 'ANO',
    value: 'ano'
  },
  {
    text: 'MÊS REF.',
    value: 'mes'
  },
  {
    text: 'MÊS 1',
    value: 'mes_1'
  },
  {
    text: 'MÊS 2',
    value: 'mes_2'
  },
  {
    text: 'MÊS 3',
    value: 'mes_3'
  },
  {
    text: 'MÊS 4',
    value: 'mes_4'
  },
  {
    text: 'MÊS 5',
    value: 'mes_5'
  },
  {
    text: 'MÊS 6',
    value: 'mes_6'
  },
  {
    text: 'MÊS 7',
    value: 'mes_7'
  },
  {
    text: 'MÊS 8',
    value: 'mes_8'
  },
  {
    text: 'MÊS 9',
    value: 'mes_9'
  },
  {
    text: 'MÊS 10',
    value: 'mes_10'
  },
  {
    text: 'MÊS 11',
    value: 'mes_11'
  },
  {
    text: 'MÊS 12',
    value: 'mes_12'
  },
];

const expanded = [
  {
    text: 'GRUPO',
    value: 'descricao'
  },
  {
    text: 'ID FORN.',
    value: 'id_forneceor',
    style: {
      textAlign: 'right',
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'FORNECEDOR',
    value: 'razao_social'
  },
  {
    text: 'ID PROD.',
    value: 'id_produto',
    style: {
      textAlign: 'right',
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'PRODUTO',
    value: 'descricao_produto'
  },
  {
    text: 'ENVIADO',
    value: 'data_envio'
  },
  {
    text: 'ANO',
    value: 'ano'
  },
  {
    text: 'MÊS REF.',
    value: 'mes',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
];

const tabela_temporaria = [
  {
    text: 'Fornecedor',
    value: 'fornecedor'
  },
  {
    text: 'Descricao Produto',
    value: 'descricao_produto'
  },
  {
    text: 'Cod Barras',
    value: 'cod_barras'
  },
  {
    text: 'ID Produto',
    value: 'id_produto'
  },
  {
    text: 'Mês 1',
    value: 'mes_1',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 2',
    value: 'mes_2',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 3',
    value: 'mes_3',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 4',
    value: 'mes_4',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 5',
    value: 'mes_5',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 6',
    value: 'mes_6',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 7',
    value: 'mes_7',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 8',
    value: 'mes_8',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 9',
    value: 'mes_9',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 10',
    value: 'mes_10',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 11',
    value: 'mes_11',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
  {
    text: 'Mês 12',
    value: 'mes_12',
    style: {
      maxWidth: '60px',
      minWidth: '60px'
    }
  },
];

export default {
  index: index,
  expanded: expanded,
  tabela_temporaria: tabela_temporaria
}
